import { render } from "./Messages.vue?vue&type=template&id=3caaf07f&scoped=true"
import script from "./Messages.vue?vue&type=script&lang=js"
export * from "./Messages.vue?vue&type=script&lang=js"

import "./Messages.vue?vue&type=style&index=0&id=3caaf07f&scoped=true&lang=css"

import exportComponent from "/usr/app/saas-stack/customer-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3caaf07f"]])

export default __exports__